/**
 * Chống getStatus chạy nhiều lần khi:
 * - native bắn liên tiếp / resume
 * - còn instance cũ chưa gỡ handler (EventEmitter stack listener)
 *
 * Pattern lấy từ miniapp_tv360 PackageDetail.
 */

let getStatusProcessing = false;
const processedGetStatusKeys = new Set();
let activeGetStatusOwner = null;

export function buildGetStatusKey(data) {
  return (
    data?.transactionId ||
    data?.orderRef ||
    (data ? JSON.stringify(data) : "")
  );
}

export function claimGetStatusOwner(owner) {
  activeGetStatusOwner = owner;
}

export function releaseGetStatusOwner(owner) {
  if (activeGetStatusOwner === owner) {
    activeGetStatusOwner = null;
  }
}

/**
 * Chỉ instance active mới xử lý; dedupe theo transactionId/orderRef.
 * @returns {Promise<boolean>} true nếu đã chạy handler
 */
export async function runGetStatusOnce(owner, data, handler) {
  if (activeGetStatusOwner !== owner) return false;
  if (getStatusProcessing) return false;

  const key = buildGetStatusKey(data);
  if (key && processedGetStatusKeys.has(key)) return false;

  getStatusProcessing = true;
  if (key) processedGetStatusKeys.add(key);

  try {
    await handler(data);
    return true;
  } finally {
    getStatusProcessing = false;
  }
}
